// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2L257","title":"AfterBackImages_title__2eb56","images":"AfterBackImages_images__1sdjb"};